/**
 * Screen title + kicker for the field-edition app chrome header.
 * Static kickers for now; pages can refine later with live stats.
 */

const BY_PAGE = {
  maps: { title: 'My Ground', kicker: 'YOUR LAND · STANDS & PLOTS' },
  clubs: { title: 'Clubs', kicker: 'YOUR CLUBS' },
  hunts: { title: 'My Hunts', kicker: 'YOUR HUNT LOG' },
  messages: { title: 'Messages', kicker: 'INBOX' },
  toolkit: { title: 'Toolkit', kicker: 'FEED · PLANTING · PRINT' },
  'hunting-buddies': { title: 'Hunting Buddies', kicker: 'YOUR PEOPLE · SHARED CLUBS' },
  'find-club': { title: 'Find a Club', kicker: 'CLUBS LOOKING FOR MEMBERS' },
  'find-processor': { title: 'Find a Processor', kicker: 'DEER PROCESSORS NEAR YOU' },
  'suggest-store': { title: 'Suggest a Store', kicker: 'FEED & SEED DIRECTORY' },
  profile: { title: 'Profile', kicker: 'ACCOUNT HUB' },
  notifications: { title: 'Notifications', kicker: 'ALERTS & UPDATES' },
  'camp-essentials': { title: 'Camp Essentials', kicker: 'GEAR · RECIPES · FIRESIDE' },
};

const BY_PATH_PREFIX = [
  ['/toolkit/hunt-forecast', { title: 'Hunt Forecast', kicker: 'STAND CONDITIONS · FEEDING WINDOWS' }],
  ['/toolkit/feed-management', { title: 'Feed Tracker', kicker: 'FEED & DRAW-DOWN' }],
  ['/toolkit/planting-assistant', { title: 'Planting', kicker: 'PLANTING ASSISTANT' }],
  ['/toolkit/printable-map', { title: 'Printable Map', kicker: 'PRINTABLE MAP' }],
  ['/hunts/log', { title: 'Log a Hunt', kicker: 'PERSONAL LOG' }],
  ['/hunts/edit', { title: 'Edit Hunt', kicker: 'PERSONAL LOG' }],
  ['/profile/account', { title: 'Account', kicker: 'BILLING & SECURITY' }],
  ['/profile/my-stuff', { title: 'My Stuff', kicker: 'PHOTOS & KEEPSAKES' }],
  ['/messages/new', { title: 'Messages', kicker: 'NEW MESSAGE' }],
  ['/users', { title: 'Buddy Profile', kicker: 'HUNTING BUDDIES' }],
];

export function getAvatarInitials(displayName) {
  const parts = String(displayName || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0][0] || ''}${parts[1][0] || ''}`.toUpperCase();
  }
  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }
  return '?';
}

export function getAppChromeMeta(currentPage, pathname = '', search = '') {
  const path = pathname || '';
  const query = typeof search === 'string' ? search : '';
  const params = new URLSearchParams(query.startsWith('?') ? query.slice(1) : query);

  if ((path === '/hunts' || path === '/hunts/') && params.get('tab') === 'forecast') {
    return { title: 'Hunt Forecast', kicker: 'STAND CONDITIONS · FEEDING WINDOWS' };
  }

  for (const [prefix, meta] of BY_PATH_PREFIX) {
    if (path === prefix || path.startsWith(`${prefix}/`)) {
      return meta;
    }
  }

  // Messages thread: /messages/:id (not /messages or /messages/new)
  if (/^\/messages\/[^/]+$/.test(path.replace(/\/+$/, '')) && path.replace(/\/+$/, '') !== '/messages/new') {
    return { title: 'Messages', kicker: 'CONVERSATION' };
  }

  if (BY_PAGE[currentPage]) {
    return BY_PAGE[currentPage];
  }
  return { title: 'Yona', kicker: 'LOVE THE LAND' };
}
